import React from 'react'
import "./style.scss";
import { useTable, usePagination } from 'react-table'
import ScoreView from '../../../../components/UI/ScoreView';
import Notation from '../../../../components/report/notation';
import styled from 'styled-components'
import { RedFlag } from '../../../../static/img/images';
import { fetchClassSubtopicOverallReport, fetchClassSubtopicSkillReport } from '../../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { textIdentifier } from '../../../../textIdentifier';


function Table({ columns, data, selectedClass }) {
    // Use the state and functions returned from useTable to build your UI
    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      page, // Instead of using 'rows', we'll use page,
      // which has only the rows for the active page
  
      // The rest of these things are super handy, too ;)
      canPreviousPage,
      canNextPage,
      pageOptions,
      pageCount,
      gotoPage,
      nextPage,
      previousPage,
      setPageSize,
      state: { pageIndex, pageSize },
    } = useTable(
      {
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 10, hiddenColumns: [selectedClass.hide_skills&&'id'] },
      },
      usePagination
    )
    const {lang} = useSelector(state => state.main)
  
    // Render the UI for your table
    return (
      <>
      <div className="list--length--select">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M7.5 6C7.5 6.39782 7.34196 6.77936 7.06066 7.06066C6.77936 7.34196 6.39782 7.5 6 7.5C5.60218 7.5 5.22064 7.34196 4.93934 7.06066C4.65804 6.77936 4.5 6.39782 4.5 6C4.5 5.60218 4.65804 5.22064 4.93934 4.93934C5.22064 4.65804 5.60218 4.5 6 4.5C6.39782 4.5 6.77936 4.65804 7.06066 4.93934C7.34196 5.22064 7.5 5.60218 7.5 6V6Z" stroke="#0059B1" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.229 6C1.866 3.9715 3.7615 2.5 6 2.5C8.239 2.5 10.134 3.9715 10.771 6C10.134 8.0285 8.239 9.5 6 9.5C3.7615 9.5 1.866 8.0285 1.229 6V6Z" stroke="#0059B1" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <select
            value={pageSize}
            onChange={e => {
                setPageSize(Number(e.target.value))
            }}
            >
            {[10,25,50].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                {pageSize}
                </option>
            ))}
        </select>
      </div>
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
        {/* 
          Pagination can be built however you'd like. 
          This is just a very basic UI implementation:
        */}
        <div className="pagination">
          {/* <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            {'<<'}
          </button>{' '} */}
          <button onClick={() => previousPage()} disabled={!canPreviousPage}>
            &#10094;{" "}
            {textIdentifier["previous-page"][lang]}
          </button>{' '}
          <button onClick={() => nextPage()} disabled={!canNextPage}>
          {textIdentifier["next-page"][lang]}{" "}
            &#10095;
          </button>{' '}
          {/* <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            {'>>'}
          </button>{' '} */}
          {/* <span>
            Page{' '}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>{' '}
          </span> */}
          {/* <span>
            | Go to page:{' '}
            <input
              type="number"
              defaultValue={pageIndex + 1}
              onChange={e => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0
                gotoPage(page)
              }}
              style={{ width: '100px' }}
            />
          </span>{' '} */}
        </div>
      </>
    )
  }


  const Styles = styled.div`

  table {
    border-spacing: 0;
    border: 0.5px solid black;
    width: 100%;
    background: #fff;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 0.5px solid black;
      border-right: 0.5px solid black;

      :last-child {
        border-right: 0;
      }
    }

    th{
        background: #D9D9D9;
        text-align: center;
    }
  }
`


function SubjectwiseReport(props) {
  const dispatch = useDispatch();
  const { selectedCompetition, selectedSchool, selectedClass, lang } = useSelector(
    (state) => state.main
  );
    const handleFloatParse = (val) => {
    return parseFloat(val).toFixed(2);
    };

    const competition_proficiency_status = (value, comp_proficiency) => (
    <ScoreView
        content={textIdentifier["overall-proficiency"][lang]+` ${parseFloat(comp_proficiency).toFixed(
        2
        )}%`}
    >
        <div>
        <Notation status={value} />
        </div>
    </ScoreView>
    );

    const school_proficiency_status = (value, school_proficiency) => (
    <ScoreView
        content={textIdentifier["school-proficiency"][lang]+` ${parseFloat(school_proficiency).toFixed(
        2
        )}%`}
    >
        <div>
        <Notation status={value} />
        </div>
    </ScoreView>
    );

    const competition_accuracy_status = (value, comp_accuracy) => (
    <ScoreView
        content={textIdentifier["overall-accuracy"][lang]+` ${parseFloat(comp_accuracy).toFixed(2)}%`}
    >
        <div>
        <Notation status={value} />
        </div>
    </ScoreView>
    );

    const school_accuracy_status = (value, school_accuracy) => (
    <ScoreView
        content={textIdentifier["school-accuracy"][lang]+` ${parseFloat(school_accuracy).toFixed(2)}%`}
    >
        <div>
        <Notation status={value} />
        </div>
    </ScoreView>
    );

    const competition_marks_status = (value, comp_marks) => (
    <ScoreView content={textIdentifier["overall-marks"][lang]+` ${parseFloat(comp_marks).toFixed(2)}`}>
        <div>
        <Notation status={value} />
        </div>
    </ScoreView>
    );

    const school_marks_status = (value, school_marks) => (
    <ScoreView content={textIdentifier["school-marks"][lang]+` ${parseFloat(school_marks).toFixed(2)}`}>
        <div>
        <Notation status={value} />
        </div>
    </ScoreView>
    );

    const handleTopicNameClick = (data) => {
      dispatch(fetchClassSubtopicOverallReport({
        classId: selectedClass.code,
        nodeId: data.original.id,
        params: {
          limit: 10,
          offset: 0
        },
        activeTopicData: {
          name: data.original.name,
          totalMarks: data.original.total_marks,
          totalQuestions: data.original.total_questions,
          nodeId: data.original.id
        }
      }))
    }

    const handleSkillNameClick = (data) => {
      dispatch(fetchClassSubtopicSkillReport({
        classId: selectedClass.code,
        nodeId: data.original.id,
        params: {
          limit: 10,
          offset: 0
        },
        activeTopicData: {
          name: data.original.name,
          totalMarks: data.original.total_marks,
          totalQuestions: data.original.total_questions,
          nodeId: data.original.id
        }
      }))
    }


    const columns = React.useMemo(
        () => [
        //   {
            // Header: 'Data',
            // columns: [
              {
                Header: textIdentifier["topic-name"][lang],
                accessor: 'name',
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <div onClick={()=>{handleTopicNameClick(row)}} className="data--cell topic--name--wrapper">
                        <div className="topic--name">
                          {row.original.name}
                        </div>
                        {
                          row.index<5
                          &&
                          <RedFlag/>
                        }
                    </div>
                )
              },
              {
                Header: textIdentifier["proficiency"][lang],
                accessor: 'proficiency',
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <div className="data--cell">
                        <div className="data--cell--row">
                            {`${row.original.proficiency}%`}
                        </div>
                        <div className="data--cell--row">
                            {competition_proficiency_status(
                                row.original.school_proficiency_status,
                                row.original.overall_competition_proficiency
                            )}
                            {school_proficiency_status(
                                row.original.class_proficiency_status,
                                row.original.overall_school_proficiency
                            )}
                        </div>
                    </div>
                )
              },
              {
                Header: textIdentifier["accuracy"][lang],
                accessor: 'accuracy',
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <div className="data--cell">
                        <div className="data--cell--row">
                            {`${row.original.accuracy}%`}
                        </div>
                        <div className="data--cell--row">
                            {competition_accuracy_status(
                                row.original.school_accuracy_status,
                                row.original.overall_competition_accuracy
                            )}
                            {school_accuracy_status(
                                row.original.class_accuracy_status,
                                row.original.overall_school_accuracy
                            )}
                        </div>
                    </div>
                )
              },
              {
                Header: textIdentifier["question-count"][lang],
                accessor: 'easy_question_count',
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <div className="data--cell">
                        <div className="data--cell--row">
                            {handleFloatParse(
                                row.original.easy_question_count +
                                row.original.medium_question_count +
                                row.original.hard_question_count
                            )}
                        </div>
                        <div className="data--cell--row">
                            {
                                `
                                    (E${handleFloatParse(row.original.easy_question_count)}, 
                                    M${handleFloatParse(row.original.medium_question_count)}, 
                                    H${handleFloatParse(row.original.hard_question_count)})
                                `
                            }
                        </div>
                    </div>
                )
              },
              {
                Header: textIdentifier["marks"][lang],
                accessor: 'marks',
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <div className="data--cell">
                        <div className="data--cell--row">
                            {handleFloatParse(row.original.marks)}
                        </div>
                        <div className="data--cell--row">
                            {competition_marks_status(
                                row.original.school_proficiency_status,
                                row.original.overall_competition_marks
                            )}
                            {school_marks_status(
                                row.original.class_proficiency_status,
                                row.original.overall_school_marks
                            )}
                        </div>
                    </div>
                )
              },
              {
                Header: textIdentifier["skills"][lang],
                accessor: 'id',
                Cell: ({ row }) => (
                    // Use Cell to render an expander for each row.
                    // We can use the getToggleRowExpandedProps prop-getter
                    // to build the expander.
                    <div onClick={()=>{handleSkillNameClick(row)}} style={{color: "#0059B1", cursor: "pointer"}} className="data--cell">
                        {row.original.skills}
                    </div>
                )
              },
            // ],
        //   }
        ],
        []
      )

    return (
        <div>
            {
                props.data.length!=0
                &&
                <Styles>
                    <Table selectedClass={selectedClass} columns={columns} data={props.data} />
                </Styles>
            }
        </div>
    )
}

export default SubjectwiseReport